export default {
  toolTip: 'View in {crmName}',
} as const;
